export const CategoriesListDefaultClassesMock = ['categories'];

export const CategoriesListDefaultPropsMock = {
  filtersTitle: 'Filter Products',
  dropdownPlaceholder: 'Select Category',
  tags: ['all', 'constipation', 'ibs'],
  allTags: ['all', 'constipation', 'ibs'],
  selectedCategories: ['all', 'constipation', 'ibs'],
  className: 'categories',
};

export const CategoriesListChildrenMock = 'test content';
